// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3eS9j","avatar":"style_avatar__1_DDw","menuIcon":"style_menuIcon__22X16"};